module.exports = __webpack_public_path__ + "media/luxury-2026/sculptural-sitting-room-62c22422.jpg";